module.exports = __webpack_public_path__ + "img/austria-cancer-female.5edf7549.png";